import { useCallback, useEffect, useRef, useState } from "react";
import { useStorageSelectors } from "../../../app/state/storageObjectSlice/hook/use-storage-selectors";
import { useAppDispatch } from "../../../services/redux/hooks/use-dispatch";
import { editStorageObject } from "../../../app/state/storageObjectSlice/actions/actions";
import { isFullHtmlDocument } from "../helpers/isFullHtmlDocument";
import { createNotification } from "../../../app/state/notificationSlice/slice";
import { getSpaUpdatedValue } from "../helpers/getSpaUpdatedValue";
import { useAppSelector } from "../../../services/redux/hooks/use-selector";
import { selectSpaValue } from "../redux/selectors";
import { setSpaValue } from "../redux/slice";
import { readFileAsText } from "../helpers";

export const useAttachedHtmlMenu = () => {
  const dispatch = useAppDispatch();
  const spaValue = useAppSelector(selectSpaValue);
  const { selectedId, selectedObject, objects } =
    useStorageSelectors("ai_agents_spa");
  const [html, setHtml] = useState<string | null>(null);

  const selectedIdRef = useRef(selectedId);
  const selectedObjectRef = useRef(selectedObject);

  selectedIdRef.current = selectedId;
  selectedObjectRef.current = selectedObject;

  useEffect(() => {
    const id = selectedIdRef.current;
    const object = selectedObjectRef.current;
    if (!id || !object || !spaValue || !html) return;

    const updatedValue = getSpaUpdatedValue(spaValue, {
      html_content: html ?? spaValue.spa_object?.html_content,
    });

    dispatch(setSpaValue(updatedValue));
    dispatch(
      editStorageObject({
        id,
        name: selectedObject?.friendly_name ?? "",
        value: updatedValue,
        service: "ai_agents_spa",
      }),
    );

    setHtml(null);
  }, [html]);

  const handleFileUpload = async (event: any) => {
    if (!event.target.files[0]) return;
    const file = event.target.files[0];
    if (!file) return;

    try {
      const htmlContent = await readFileAsText(file);
      if (!isFullHtmlDocument(htmlContent)) {
        dispatch(
          createNotification(
            "warning",
            "Содержимое файла не является полным HTML-документом",
          ),
        );
        return;
      }
      setHtml(htmlContent);
    } catch (error) {
      console.error("Ошибка при чтении файла:", error);
      dispatch(
        createNotification(
          "error",
          "Не удалось прочитать файл. Попробуйте снова.",
        ),
      );
    }
  };

  const handleChangeHtml = useCallback(async () => {
    const text = await navigator.clipboard.readText();
    if (!isFullHtmlDocument(text)) {
      dispatch(
        createNotification(
          "warning",
          "Содержимое буфера обмена не является полным HTML-документом",
        ),
      );
      return;
    }
    setHtml(text);
  }, []);

  return {
    handleFileUpload,
    handleChangeHtml,
  };
};
